// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-profile-image {
  width: 200px;
  height: auto;
}

.header-image-wrapper {
  position: relative;
  overflow: hidden;
  margin-top: -72px;
  padding-top: 36px;
}
.header-image-wrapper .header-image-content {
  position: relative;
  min-height: 320px;
  color: #fff;
  z-index: 1;
  padding-bottom: 0px !important;
}
.header-image-wrapper .header-image-content.offset-bottom {
  padding-bottom: 80px;
  min-height: 400px;
}
.header-image-wrapper .header-image-content.home-page {
  min-height: 400px;
}
.header-image-wrapper .header-image-content .title {
  font-size: 58px !important;
  padding: 0 16px;
  text-align: center;
}
.header-image-wrapper .header-image-content .desc {
  margin: 0;
  font-size: 28px;
  font-style: italic;
  padding: 0 16px;
  text-align: center;
}
.header-image-wrapper .header-image-content .mat-raised-button {
  color: rgba(0, 0, 0, 0.87);
  background-color: white;
  text-transform: uppercase;
  margin: 0 4px;
}
.header-image-wrapper .mask {
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: 1;
}
.header-image-wrapper .bg {
  width: 110%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.header-image-wrapper .bg-anime {
  -webkit-animation-name: MOVE-BG;
  -webkit-animation-duration: 15s;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-direction: alternate;
  -moz-animation-name: MOVE-BG;
  -moz-animation-duration: 15s;
  -moz-animation-timing-function: ease-in-out;
  -moz-animation-iteration-count: infinite;
  -moz-animation-direction: alternate;
  -ms-animation-name: MOVE-BG;
  -ms-animation-duration: 15s;
  -ms-animation-timing-function: ease-in-out;
  -ms-animation-iteration-count: infinite;
  -ms-animation-direction: alternate;
  animation-name: MOVE-BG;
  animation-duration: 15s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
.header-image-wrapper.fullscreen {
  height: calc(100vh - 72px) !important;
}
.header-image-wrapper.fullscreen .header-image-content {
  height: calc(100vh - 72px) !important;
}
.header-image-wrapper.fullscreen.toolbar-2 {
  height: calc(100vh - 166px) !important;
}
.header-image-wrapper.fullscreen.toolbar-2 .header-image-content {
  height: calc(100vh - 166px) !important;
}
@keyframes MOVE-BG {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-7%);
  }
}
.header-image-wrapper[dir=rtl] .bg-anime {
  animation-name: MOVE-BG-RTL;
}
@keyframes MOVE-BG-RTL {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(7%);
  }
}
@media screen and (max-width: 599px) {
  .header-image-wrapper .header-image-content {
    min-height: 240px;
  }
  .header-image-wrapper .header-image-content.offset-bottom {
    min-height: 320px;
  }
  .header-image-wrapper .header-image-content.home-page {
    min-height: 400px;
  }
  .header-image-wrapper .header-image-content .title {
    font-size: 30px !important;
  }
  .header-image-wrapper .header-image-content .desc {
    font-size: 20px;
  }
}
@media screen and (min-width: 600px) and (max-width: 959px) {
  .header-image-wrapper .header-image-content {
    min-height: 280px;
  }
  .header-image-wrapper .header-image-content.offset-bottom {
    min-height: 360px;
  }
  .header-image-wrapper .header-image-content.home-page {
    min-height: 440px;
  }
  .header-image-wrapper .header-image-content .title {
    font-size: 40px !important;
  }
  .header-image-wrapper .header-image-content .desc {
    font-size: 22px;
  }
}
h1 {
  font-weight: 400 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/header-image/header-image.component.scss","webpack://./src/app/theme/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AADF;AAGE;EACE,kBAAA;EACA,iBCVsB;EDWtB,WAAA;EACA,UAAA;EAgCA,8BAAA;AAhCJ;AAEI;EACE,oBCX8B;EDY9B,iBAAA;AAAN;AAGI;EACE,iBAAA;AADN;AAII;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;AAFN;AAKI;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAHN;AAMI;EACE,0BAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;AAJN;AAUE;EACE,8BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AARJ;AAWE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AATJ;AAYE;EACE,+BAAA;EACA,+BAAA;EACA,8CAAA;EACA,2CAAA;EACA,sCAAA;EACA,4BAAA;EACA,4BAAA;EACA,2CAAA;EACA,wCAAA;EACA,mCAAA;EACA,2BAAA;EACA,2BAAA;EACA,0CAAA;EACA,uCAAA;EACA,kCAAA;EACA,uBAAA;EACA,uBAAA;EACA,sCAAA;EACA,mCAAA;EACA,8BAAA;AAVJ;AAaE;EACE,qCAAA;AAXJ;AAaI;EACE,qCAAA;AAXN;AAcI;EACE,sCAAA;AAZN;AAcM;EACE,sCAAA;AAZR;AAgDA;EACE;IACE,wBAAA;EArBF;EAwBA;IACE,0BAAA;EAtBF;AACF;AA0BE;EAIE,2BAAA;AAxBJ;AA0DA;EACE;IACE,wBAAA;EA/BF;EAkCA;IACE,yBAAA;EAhCF;AACF;AAoCA;EAEI;IACE,iBAAA;EAnCJ;EAqCI;IACE,iBAAA;EAnCN;EAsCI;IACE,iBAAA;EApCN;EAuCI;IACE,0BAAA;EArCN;EAwCI;IACE,eAAA;EAtCN;AACF;AA4CA;EAEI;IACE,iBAAA;EA3CJ;EA6CI;IACE,iBAAA;EA3CN;EA8CI;IACE,iBAAA;EA5CN;EA+CI;IACE,0BAAA;EA7CN;EAgDI;IACE,eAAA;EA9CN;AACF;AAmDA;EACE,2BAAA;AAjDF","sourcesContent":["@import \"../../theme/styles/variables\";\r\n\r\n.c-profile-image {\r\n  width: 200px;\r\n  height: auto;\r\n}\r\n\r\n.header-image-wrapper {\r\n  position: relative;\r\n  overflow: hidden;\r\n  margin-top: -$main-toolbar-height;\r\n  padding-top: calc($main-toolbar-height/2);\r\n\r\n  .header-image-content {\r\n    position: relative;\r\n    min-height: $header-image-min-height;\r\n    color: #fff;\r\n    z-index: 1;\r\n\r\n    &.offset-bottom {\r\n      padding-bottom: $main-content-header-offset-to-top;\r\n      min-height: $header-image-min-height + $main-content-header-offset-to-top;\r\n    }\r\n\r\n    &.home-page {\r\n      min-height: $header-image-min-height + $main-content-header-offset-to-top;\r\n    }\r\n\r\n    .title {\r\n      font-size: 58px !important;\r\n      padding: 0 16px;\r\n      text-align: center;\r\n    }\r\n\r\n    .desc {\r\n      margin: 0;\r\n      font-size: 28px;\r\n      font-style: italic;\r\n      padding: 0 16px;\r\n      text-align: center;\r\n    }\r\n\r\n    .mat-raised-button {\r\n      color: rgba(0, 0, 0, 0.87);\r\n      background-color: white;\r\n      text-transform: uppercase;\r\n      margin: 0 4px;\r\n    }\r\n\r\n    padding-bottom: 0px !important;\r\n  }\r\n\r\n  .mask {\r\n    background: rgba(0, 0, 0, 0.4);\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    overflow: hidden;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1;\r\n  }\r\n\r\n  .bg {\r\n    width: 110%;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n  }\r\n\r\n  .bg-anime {\r\n    -webkit-animation-name: MOVE-BG;\r\n    -webkit-animation-duration: 15s;\r\n    -webkit-animation-timing-function: ease-in-out;\r\n    -webkit-animation-iteration-count: infinite;\r\n    -webkit-animation-direction: alternate;\r\n    -moz-animation-name: MOVE-BG;\r\n    -moz-animation-duration: 15s;\r\n    -moz-animation-timing-function: ease-in-out;\r\n    -moz-animation-iteration-count: infinite;\r\n    -moz-animation-direction: alternate;\r\n    -ms-animation-name: MOVE-BG;\r\n    -ms-animation-duration: 15s;\r\n    -ms-animation-timing-function: ease-in-out;\r\n    -ms-animation-iteration-count: infinite;\r\n    -ms-animation-direction: alternate;\r\n    animation-name: MOVE-BG;\r\n    animation-duration: 15s;\r\n    animation-timing-function: ease-in-out;\r\n    animation-iteration-count: infinite;\r\n    animation-direction: alternate;\r\n  }\r\n\r\n  &.fullscreen {\r\n    height: calc(100vh - #{$main-toolbar-height}) !important;\r\n\r\n    .header-image-content {\r\n      height: calc(100vh - #{$main-toolbar-height}) !important;\r\n    }\r\n\r\n    &.toolbar-2 {\r\n      height: calc(100vh - 166px) !important;\r\n\r\n      .header-image-content {\r\n        height: calc(100vh - 166px) !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@-webkit-keyframes MOVE-BG {\r\n  from {\r\n    -webkit-transform: translateX(0);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: translateX(-7%);\r\n  }\r\n}\r\n\r\n@-moz-keyframes MOVE-BG {\r\n  from {\r\n    -moz-transform: translateX(0);\r\n  }\r\n\r\n  to {\r\n    -moz-transform: translateX(-7%);\r\n  }\r\n}\r\n\r\n@-ms-keyframes MOVE-BG {\r\n  from {\r\n    -ms-transform: translateX(0);\r\n  }\r\n\r\n  to {\r\n    -ms-transform: translateX(-7%);\r\n  }\r\n}\r\n\r\n@keyframes MOVE-BG {\r\n  from {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  to {\r\n    transform: translateX(-7%);\r\n  }\r\n}\r\n\r\n.header-image-wrapper[dir=\"rtl\"] {\r\n  .bg-anime {\r\n    -webkit-animation-name: MOVE-BG-RTL;\r\n    -moz-animation-name: MOVE-BG-RTL;\r\n    -ms-animation-name: MOVE-BG-RTL;\r\n    animation-name: MOVE-BG-RTL;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes MOVE-BG-RTL {\r\n  from {\r\n    -webkit-transform: translateX(0);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: translateX(7%);\r\n  }\r\n}\r\n\r\n@-moz-keyframes MOVE-BG-RTL {\r\n  from {\r\n    -moz-transform: translateX(0);\r\n  }\r\n\r\n  to {\r\n    -moz-transform: translateX(7%);\r\n  }\r\n}\r\n\r\n@-ms-keyframes MOVE-BG-RTL {\r\n  from {\r\n    -ms-transform: translateX(0);\r\n  }\r\n\r\n  to {\r\n    -ms-transform: translateX(7%);\r\n  }\r\n}\r\n\r\n@keyframes MOVE-BG-RTL {\r\n  from {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  to {\r\n    transform: translateX(7%);\r\n  }\r\n}\r\n\r\n// xs\r\n@media screen and (max-width: 599px) {\r\n  .header-image-wrapper {\r\n    .header-image-content {\r\n      min-height: $header-image-min-height - 80px;\r\n\r\n      &.offset-bottom {\r\n        min-height: $header-image-min-height + $main-content-header-offset-to-top - 80px;\r\n      }\r\n\r\n      &.home-page {\r\n        min-height: $header-image-min-height + $main-content-header-offset-to-top;\r\n      }\r\n\r\n      .title {\r\n        font-size: 30px !important;\r\n      }\r\n\r\n      .desc {\r\n        font-size: 20px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// sm\r\n@media screen and (min-width: 600px) and (max-width: 959px) {\r\n  .header-image-wrapper {\r\n    .header-image-content {\r\n      min-height: $header-image-min-height - 40px;\r\n\r\n      &.offset-bottom {\r\n        min-height: $header-image-min-height + $main-content-header-offset-to-top - 40px;\r\n      }\r\n\r\n      &.home-page {\r\n        min-height: $header-image-min-height + $main-content-header-offset-to-top + 40px;\r\n      }\r\n\r\n      .title {\r\n        font-size: 40px !important;\r\n      }\r\n\r\n      .desc {\r\n        font-size: 22px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nh1 {\r\n  font-weight: 400 !important;\r\n}","$font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n$theme-max-width: 1300px;\r\n$top-toolbar-height: 36px;\r\n$main-toolbar-height: 72px;\r\n$user-menu-width: 220px;\r\n$header-image-min-height: 320px;\r\n$header-video-min-height: 360px;\r\n$header-carousel-height: 460px;\r\n$header-map-height: 550px;\r\n$main-content-header-offset-to-top: 80px;\r\n\r\n$main-sidenav-width: 265px;\r\n$search-sidenav-width: 288px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
